const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
});

/** `2500` -> `$2,500`; `0` -> `Free`. */
export function formatPrice(amountUsd: number): string {
  return amountUsd === 0 ? 'Free' : usdFormatter.format(amountUsd);
}
